import PrincipleModal from './PrincipleModal'

export default PrincipleModal;
